"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockArcxRedemptionFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockArcxRedemptionFactory = /** @class */ (function (_super) {
    __extends(MockArcxRedemptionFactory, _super);
    function MockArcxRedemptionFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockArcxRedemptionFactory.prototype.deploy = function (_usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides) {
        return _super.prototype.deploy.call(this, _usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides || {});
    };
    MockArcxRedemptionFactory.prototype.getDeployTransaction = function (_usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides || {});
    };
    MockArcxRedemptionFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockArcxRedemptionFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockArcxRedemptionFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockArcxRedemptionFactory;
}(contracts_1.ContractFactory));
exports.MockArcxRedemptionFactory = MockArcxRedemptionFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_usdcAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_arcxAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_exchangeRate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_cutoffDate",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_redeemer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_arcxGiven",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_usdcReturned",
                type: "uint256",
            },
        ],
        name: "Redemption",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_destination",
                type: "address",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "arcxToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cutoffDate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "redeem",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "usdcToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_destination",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
